import React from 'react';
import { CustomButton, Modifiers } from '@fw-nextgen/fw-components';
import Modal from 'rc-dialog';
import { FormattedMessage } from 'react-intl';
import Countdown, { CountdownRenderProps } from 'react-countdown';
import {
  DialogActionType,
  IModalProps
} from '@app/src/common/store/ModalStore';
import IconModalWarning from '../assets/icon-modal-warning.svg';

import './ReloadModal.scss';

const TIMER_VALUE = 30000;

const ReloadModal = ({ onClose }: IModalProps) => {
  const onSubmit = () => {
    onClose(DialogActionType.submit);
  };

  const renderer = ({ seconds }: CountdownRenderProps) => (
    <p className="reload-modal__info">
      <FormattedMessage
        id="app.reload.modal.info"
        values={{ value: seconds }}
      />
    </p>
  );

  return (
    <Modal className="reload-modal" destroyOnClose={true} visible>
      <div className="reload-modal__wrapper">
        <IconModalWarning />
      </div>
      <h3 className="reload-modal__title">
        <FormattedMessage id="app.reload.modal.title" />
      </h3>
      <p className="reload-modal__description">
        <FormattedMessage id="app.reload.modal.description" />
      </p>
      <Countdown
        date={Date.now() + TIMER_VALUE}
        renderer={renderer}
        onComplete={onSubmit}
      />
      <div className="reload-modal__button-wrapper">
        <CustomButton
          id="conf_submit"
          value="app.reload.modal.button"
          modifiers={[Modifiers.SMALL]}
          onClick={onSubmit}
        />
      </div>
    </Modal>
  );
};

export default ReloadModal;
